import * as React from "react";
import { inject, observer } from "mobx-react";
import { AdvertisingStore } from "src/stores/AdvertisingStore";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { IntentMedia } from "src/components/utility/Ads/IntentMedia";

interface AdScriptsProps {
  advertising?: AdvertisingStore;
  context: ExtendedContextStore;
  pageName: string;
}

@inject("advertising")
@observer
export class AdScripts extends React.Component<AdScriptsProps> {
  private window: any;

  constructor(props: AdScriptsProps) {
    super(props);
    this.handleAdBlockDetect = this.handleAdBlockDetect.bind(this);
  }

  public componentDidMount() {
    this.window = window;
  }

  public componentWillUnmount() {
    // Clear the ADS cache.
    this.window.meso = this.window.meso || {};
    this.window.meso.initialize = this.window.meso.initialize || [];
    this.window.meso.initialize.push({ type: "clear" });
  }

  /**
   * Checks the context to see if the user enables tracking for ads
   * Alternatively, checks OIP cookie which is set from the bernie banner
   */
  private getPrivacyConsent() {
    const context = this.props.context;
    const optInPrivacy = context && context.site && context.site.optInPrivacyInfo;
    const canTrack = (optInPrivacy && optInPrivacy.canTrack) || false;
    // canSell defaults to true unless explicitly false
    const canSell = !(optInPrivacy && optInPrivacy.canSell === false);

    return {
      canTrack,
      canSell
    };
  }

  private handleAdBlockDetect() {
    const { advertising } = this.props;
    if (advertising) {
      advertising.adBlockerEnabled = typeof this.window.adblock === "undefined" ? true : Boolean(this.window.adblock);
    }
  }

  public render() {
    const { advertising, pageName, context } = this.props;
    const mesoInitialized =
      this.window && this.window.meso && this.window.meso.initialize && this.window.meso.initialize.isEventQueue;

    if (advertising && advertising.includeAdLoader && !mesoInitialized) {
      const adBlockDetectScript = document.createElement("script");
      adBlockDetectScript.src = advertising.adBlockDetect;
      adBlockDetectScript.onerror = adBlockDetectScript.onload = this.handleAdBlockDetect;
      document.body.appendChild(adBlockDetectScript);

      const script = document.createElement("script");
      script.src = advertising.adsloader;
      script.type = "module";
      document.body.appendChild(script);

      // This is for older es5 browsers that don't support module type
      const fallbackScript = document.createElement("script");
      fallbackScript.src = advertising.adsloaderFallback;
      fallbackScript.defer = true;
      fallbackScript.noModule = true;
      document.body.appendChild(fallbackScript);
      const { canTrack, canSell } = this.getPrivacyConsent();

      if (this.window) {
        const target = {
          pageId: pageName,
          siteId: context && context.site && context.site.id,
          locale: context && context.locale,
          variant: "pwa",
          brand: context && context.site && context.site.brand,
          canTrack,
          canSell
        };

        this.window.meso = this.window.meso || {};
        this.window.meso.initialize = this.window.meso.initialize || [];
        this.window.meso.initialize.push(target);
        this.window.meso.targeting = this.window.meso.targeting || [];
        this.window.meso.targeting.push({ adinfo: {} });
        // Push the application to the breakpoints framework.
        this.window.meso.breakpoints = this.window.meso.breakpoints || [];
        this.window.meso.breakpoints.push({ type: "platform", platform: "bernie" });
        if (advertising.CMPTST) {
          this.window.meso.targeting.push({ targeting: { CMPTST: advertising.CMPTST } });
        }
      }
    }

    return <IntentMedia context={context} />;
  }
}
